
import { useState } from 'react';
import { motion } from 'framer-motion';
import { Cookie } from 'lucide-react';

interface FortuneCookieProps {
  onClick: () => void;
  disabled: boolean;
}

const FortuneCookie = ({ onClick, disabled }: FortuneCookieProps) => {
  const [isAnimating, setIsAnimating] = useState(false);
  
  const handleClick = () => {
    if (disabled || isAnimating) return;
    
    setIsAnimating(true);
    setTimeout(() => {
      onClick();
      setTimeout(() => setIsAnimating(false), 300);
    }, 600);
  };
  
  return (
    <motion.div
      className={`relative w-48 h-48 cursor-pointer select-none cookie-shadow
        ${disabled ? 'opacity-70 cursor-not-allowed' : 'hover:scale-105'}
        transition-all duration-300 ease-out`}
      onClick={handleClick}
      whileHover={!disabled ? { y: -5 } : undefined}
      animate={isAnimating ? { scale: [1, 1.1, 1] } : { scale: 1, opacity: 1 }}
      initial={{ scale: 0.9, opacity: 0 }}
      transition={{ duration: 0.5, ease: "easeOut" }}
    >
      <motion.div
        className="absolute inset-0 flex items-center justify-center"
        animate={isAnimating ? { rotateY: 180 } : {}}
        transition={{ duration: 0.6, ease: "easeInOut" }}
      >
        <Cookie 
          size={160} 
          className={`text-cookie-light stroke-cookie-dark ${isAnimating ? 'animate-crack' : 'animate-float'}`}
        />
      </motion.div>
      
      {!disabled && !isAnimating && (
        <motion.div 
          className="absolute bottom-0 left-1/2 transform -translate-x-1/2 translate-y-8 text-sm text-muted-foreground"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.3 }}
        >
          Tap to open
        </motion.div>
      )}
    </motion.div>
  );
};

export default FortuneCookie;
